import React, { useState, useEffect } from "react";
import {
  Col,
  Form,
  Row,
  Table,
  Image,
  // Modal,
  Container,
  Button,
} from "react-bootstrap";
import moment from "moment";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import { Menu, MenuItem } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

import { FormControl, InputLabel, Select, TextField } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import BasicPagination from "../../../Pagination/Pagination";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { settlementSummary } from "../../../../store/actions/VendorReports/vendorReportsRestaurant";
import SelectFilter from "../../../reusableComponents/selectFilter";
import isEmpty from "../../../../store/validation/is-Empty";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import { expPaymentStatusBadge, expStatusBadge, SETTLEMENT_TYPE } from "../../../../enums/GlobalEnums";
import { amApi } from "../../../../api/apiHelper";
import { stat } from "fs";
import { RightSideCountTop } from "../../OrderReports/RightSideCountTop";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


const VendorExpReport = (props) => {
  const history = useHistory();
  const [showFilter, setshowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);


  const [report, setReport] = useState([]);
  const expData = history.location.state.data;
  const dateQuery = history.location.state.dateQuery;

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const getData = async (data) => {
    let query = { type: 'expRequests', vendorId: data.vendorId, expId: data._id }
    let expData = await amApi.get('/admin/expRequest', { params: query });
    if (expData.data?.length > 0) {
      setReport(expData.data);
    }
  }

  useEffect(() => {

    if (!isEmpty(expData)) {
      getData(expData);
    }

  }, [expData]);


  let tempData = report;



  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation
              leftText="vendorReview"
              backButtonLink="/experiencereport"
              displayText="Back"
            />
            <Container fluid>
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="super_admin_add_vendor mb-4">
                    <h5 className="main_header_text">
                      {expData.name}
                    </h5>
                    <p style={{ color: "#EE3A23" }} className="f12-400">Experience Id : {expData.expId}</p>
                    <div className="f12-700">
                      {moment(dateQuery?.startDate).format("ll")} -{" "}
                      {moment(dateQuery?.endDate).format("ll")}
                    </div>
                  </div>
                  <div className="text-right" align="right">
                    <RightSideCountTop
                      content={[
                        {
                          name: "Availed Count",
                          value: expData.seatsBooked || 0,
                          backgroundColor: "#FFEDE9",
                          color: "#EE3A23",
                        },
                        {
                          name: "Viewed Count",
                          value: expData?.expViews,
                          backgroundColor: "#EFEBFB",
                          color: "#6F32C9",
                        }
                      ]}
                    />
                  </div>
                </div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead style={{ fontSize: "10px" }}>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "14%" }} className="f12-700">
                          User
                        </th>
                        <th style={{ width: "14%" }} className="f12-700">
                          Experience<br />Status
                        </th>
                        <th style={{ width: "14%" }} className="f12-700">
                          Total PAX/
                          <br /> Ticket No.
                        </th>
                        <th style={{ width: "14%" }} className="f12-700">
                          Ticket Total /
                          <br /> Amount
                        </th>
                        <th style={{ width: "14%" }} className="f12-700">
                          Net <br /> Remitted
                        </th>
                        <th style={{ width: "14%" }} className="f12-700">
                          Discount
                        </th>
                        <th style={{ width: "14%" }} className="f12-700">
                          Donation
                        </th>
                        <th style={{ width: "14%" }} className="f12-700">
                          Payment <br /> Status
                        </th>
                      </tr>
                    </thead>
                    {tempData?.slice(start, end).map((data, index) => {
                      return (
                        <tbody>
                          <tr className="super_admin_all_users_table_body" key={data._id}>
                            <td style={{ width: "14%" }} className="f9-400">
                              <div className="f12-400">{data.userDetails.name}</div>
                            </td>
                            <td style={{ width: "14%" }} className="f9-400">
                              <div className={`f12-400 badge ${expStatusBadge[data.status].badge}`}>{expStatusBadge[data.status].name}</div>
                              <div className="f12-400">{moment(data.updatedAt).format('ll')}</div>
                              <div className="f12-400">{moment(data.updatedAt).format('LT')}</div>
                            </td>
                            <td style={{ width: '14%' }} className="f12-500">
                              <div className="f12-400">{data.adultCount + data.kidsCount + data.package.adults + data.package.kids} PAX /</div>
                              <div className="f12-400">{data.requestId}</div>
                            </td>
                            <td style={{ width: "14%" }} className="f12-500">
                              <div className="f10-400">{data.paymentData.totalAmount}</div>
                            </td>
                            <td style={{ width: "14%" }} className="f12-500">
                              <div className="f10-400">-</div>
                            </td>
                            <td style={{ width: "14%" }} className="f12-500">
                              <div className="f12-400">-</div>
                            </td>
                            <td style={{ width: "14%" }} className="f12-500">
                              <div className="f12-400">{data.paymentData.donationAmount}</div>
                            </td>
                            <td style={{ width: "14%" }} className="f9-400">
                              <div className={`f12-400 badge ${expPaymentStatusBadge[data.paymentStatus].badge}`}>{expPaymentStatusBadge[data.paymentStatus].name}</div>
                              <div className="f12-400">{moment(data.transactionDetails.find(e => e.paid).date).format('ll')}</div>
                              <div className="f12-400">{moment(data.transactionDetails.find(e => e.paid).date).format('LT')}</div>
                            </td>
                          </tr>
                        </tbody>
                      )
                    })}
                  </Table>
                </div>
                <div className="p4v2-menu-pagination">
                  <BasicPagination
                    totalRecords={tempData?.length}
                    limit={10}
                    batch={page}
                    onBatchChange={(e) => handleBatchChange(e)}
                  />
                </div>
              </div>
            </Container>
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </div >
    </React.Fragment >
  );
};


export default VendorExpReport;
